// extracted by mini-css-extract-plugin
module.exports = {"introRow":"index-module--intro-row--MXLT1","introBox":"index-module--intro-box--2PImQ","spaceship":"index-module--spaceship--1LVMT","paintSplat":"index-module--paint-splat--24wQJ"};